import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/orders/$orderId/")({
  head: () => ({
    meta: [{ title: "订单详情 · imiker CRM" }],
  })
});
